export default __webpack_public_path__ + "4c4d804fd68b904d6a931f555fb07321.png";